<div style="height: 90vh !important" class="card card-custom d-flex flex-column">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ getTitle() | translate }}</h3>
    </div>
  </div>
  <div
    style="max-height: unset !important"
    class="card-body flex-grow-1 scroll"
    [perfectScrollbar]="{ wheelPropagation: false }"
  >
    <div class="form form-group mb-0">
      <div *ngIf="!mapped" class="alert alert-custom alert-light-danger fade show px-6 py-2 mb-10">
        <div class="alert-icon">
          <i style="font-size: 1.6rem !important" class="flaticon-warning"></i>
        </div>
        <div class="alert-text">Template keys should be all mapped!</div>
        <div class="alert-close">
          <button type="button" class="close" data-dismiss="alert">
            <i class="ki ki-close"></i>
          </button>
        </div>
      </div>
      <div *ngIf="linked" class="alert alert-custom alert-light-warning fade show px-6 py-2 mb-10">
        <div class="alert-icon">
          <i style="font-size: 1.6rem !important" class="flaticon-warning"></i>
        </div>
        <div class="alert-text">Selected Form and Template are already linked!</div>
        <div class="alert-close">
          <button type="button" class="close" data-dismiss="alert">
            <i class="ki ki-close"></i>
          </button>
        </div>
      </div>
      <div class="d-flex mb-6">
        <div [class.custom-field]="link.model" class="flex-grow-1">
          <div>
            <kt-general-autocomplete
              #formAutocomplete
              [label]="'FORMS_TEMPLATES_MODULE.MAPPING.FORM' | translate"
              [appearance]="'fill'"
              [dataPath]="'data'"
              [loadItemsFunction]="getFormAutocomplete"
              [optionFormatter]="formatFormOption"
              [valueFormatter]="formatFormOption"
              [control]="formAutocomplete"
              [change]="handleFormChange.bind(this)"
              [required]="true"
              [readOnly]="link.model"
            ></kt-general-autocomplete>
          </div>
          <button
            *ngIf="link.model"
            matTooltip="{{ 'TABLE.VIEW' | translate }} Form Schema"
            class="btn btn-icon btn-light-primary btn-hover-primary"
            (click)="viewFormSchema($event)"
          >
            <span
              inlineSVG="assets/media/svg/icons/General/visible.svg"
              class="svg-icon svg-icon-lg svg-icon-primary"
            ></span>
          </button>
        </div>
        <div [class.custom-field]="link.template" class="flex-grow-1 ml-4">
          <div>
            <kt-general-autocomplete
              #templateAutocomplete
              [label]="'FORMS_TEMPLATES_MODULE.MAPPING.TEMPLATE' | translate"
              [appearance]="'fill'"
              [dataPath]="'data'"
              [loadItemsFunction]="getTemplateAutocomplete"
              [optionFormatter]="formatTemplateOption"
              [valueFormatter]="formatTemplateOption"
              [control]="templateAutocomplete"
              [change]="handleTemplateChange.bind(this)"
              [required]="true"
              [readOnly]="link.template"
            ></kt-general-autocomplete>
          </div>
          <button
            *ngIf="link.template"
            matTooltip="{{ 'TABLE.DOWNLOAD' | translate }} Template File"
            class="btn btn-icon btn-light-primary btn-hover-primary"
            (click)="downloadTemplateFile($event)"
          >
            <span
              inlineSVG="assets/media/svg/icons/Files/Download.svg"
              class="svg-icon svg-icon-lg svg-icon-primary"
            ></span>
          </button>
        </div>
      </div>
      <div class="w-100 mb-6">
        <kt-general-autocomplete
          #categoryAutocomplete
          [label]="'FORMS_TEMPLATES_MODULE.MAPPING.CATEGORY' | translate"
          [dataPath]="'data'"
          [hint]="'Document Category'"
          [control]="categoryAutocomplete"
          [loadItemsFunction]="getCategoryAutocomplete"
          [optionFormatter]="formatCategoryOption"
          [valueFormatter]="formatCategoryOption"
          [required]="true"
        ></kt-general-autocomplete>
      </div>
      <div>
        <div class="d-flex align-items-center justify-content-between mb-4">
          <label style="padding-left: 0.75em !important" class="font-weight-bolder"
            >Mapping <span [class.text-danger]="!mapped">*</span></label
          >
          <button
            *ngIf="link.require_reset"
            #copyBtn
            class="btn btn-md btn-light-primary btn-hover-primary"
            (click)="copyPrevMapping($event, copyBtn)"
          >
            <span class="fa fa-copy"></span>
            <span class="font-weight-normal ml-2">Copy Previous Mapping</span>
          </button>
        </div>
        <div class="d-flex mb-4">
          <div class="flex-grow-1 d-flex align-items-stretch">
            <div class="w-50">
              <mat-form-field appearance="fill">
                <mat-label>Form Field</mat-label>
                <mat-select #formField [disabled]="!formAutocomplete.value">
                  <mat-option value=""></mat-option>
                  <mat-option *ngFor="let field of formFields" [value]="field">{{
                    field
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="w-50 ml-4">
              <mat-form-field
                appearance="fill"
                [matTooltip]="
                  templateKeys.length || !templateAutocomplete.value ? null : 'All keys mapped!'
                "
                [matTooltipPosition]="'above'"
              >
                <mat-label>Template Key</mat-label>
                <mat-select #templateKey [disabled]="!templateAutocomplete.value">
                  <mat-option *ngFor="let key of templateKeys" [value]="key">{{ key }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div
            [matTooltip]="
              !templateKey.value
                ? 'Select Key!'
                : ((mapIndex ? 'TABLE.UPDATE' : 'TABLE.ADD') | translate)
            "
            [matTooltipPosition]="'above'"
          >
            <button
              [disabled]="!templateKey.value"
              class="btn btn-icon btn-light btn-hover-success btn-sm ml-4"
              (click)="addEditMap($event)"
            >
              <span
                [inlineSVG]="
                  mapIndex
                    ? 'assets/media/svg/icons/General/edit_icon.svg'
                    : 'assets/media/svg/icons/Navigation/Plus.svg'
                "
                class="svg-icon svg-icon-md svg-icon-success"
              ></span>
            </button>
          </div>
        </div>
        <div>
          <div
            class="d-flex align-items-stretch border border-secondary rounded font-weight-bold p-2 mb-2"
          >
            <div class="flex-grow-1 d-flex align-items-center">
              <div class="w-50 px-2">Form Field</div>
              <div class="w-50 px-2">Template Key</div>
            </div>
            <div style="width: 85px !important" class="px-2">Actions</div>
          </div>
          <div>
            <div
              *ngIf="!mapping.length"
              style="height: 80px !important"
              class="d-flex flex-center font-weight-bold"
            >
              No Mapping Found!
            </div>
            <div
              *ngFor="let map of mapping; let idx = index"
              class="d-flex align-items-stretch border-bottom px-2 py-1 mb-1"
            >
              <div class="flex-grow-1 d-flex align-items-center">
                <div class="w-50 px-2">{{ map.source }}</div>
                <div class="w-50 px-2">{{ map.destination }}</div>
              </div>
              <div style="width: 85px !important" class="px-2">
                <button
                  [matTooltip]="'TABLE.UPDATE' | translate"
                  class="btn btn-icon btn-light btn-hover-primary btn-sm"
                  (click)="prepareEditMap($event, idx)"
                >
                  <span
                    inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                    class="svg-icon svg-icon-md svg-icon-primary"
                  ></span>
                </button>
                <button
                  [matTooltip]="'TABLE.DELETE' | translate"
                  class="btn btn-icon btn-light btn-hover-danger btn-sm ml-2"
                  (click)="deleteMap($event, idx)"
                >
                  <span
                    inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                    class="svg-icon svg-icon-md svg-icon-danger"
                  ></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button
      mat-raised-button
      cdkFocusInitial
      style="width: 100px !important"
      class="btn btn-sm btn-light"
      (click)="closeDialog($event)"
    >
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      mat-raised-button
      [disabled]="linked"
      style="width: 100px !important"
      class="btn btn-sm btn-primary ml-4"
      (click)="submit($event)"
    >
      {{ 'GLOBAL.SAVE' | translate }}
    </button>
  </div>
</div>
